import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { store } from "@/lib/store";
import { gaPageview, disableGA } from "@/lib/analytics";
import { useApp } from "@/context/AppContext";

export const openCookieSettings = () => window.dispatchEvent(new Event("ukready:cookie-settings"));

export function CookieNotice() {
  const { t } = useApp();
  const { pathname } = useLocation();
  const [show, setShow] = useState(() => store.getConsent() === null);

  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener("ukready:cookie-settings", open);
    return () => window.removeEventListener("ukready:cookie-settings", open);
  }, []);

  useEffect(() => { const id = setTimeout(() => gaPageview(pathname), 300); return () => clearTimeout(id); }, [pathname]);

  if (!show) return null;
  const choose = (v) => {
    store.setConsent(v);
    setShow(false);
    if (v === "granted") gaPageview(pathname); else disableGA();
  };
  return (
    <div data-testid="cookie-notice" data-print-hide role="dialog" aria-label={t("cookie.title")}
      className="fixed bottom-20 md:bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:max-w-sm z-50 rounded-xl border border-slate-200 bg-white shadow-xl p-4 animate-fade-up">
      <div className="flex items-start gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-unionblue text-white"><Cookie className="h-5 w-5" /></span>
        <div>
          <p className="font-heading font-bold text-navy text-sm">{t("cookie.title")}</p>
          <p className="text-sm text-slate-600 mt-1">{t("cookie.body")} <Link to="/privacy" className="text-royal font-semibold underline">{t("cookie.link")}</Link>.</p>
          <div className="mt-3 flex gap-2">
            <button data-testid="cookie-accept" onClick={() => choose("granted")} className="touch rounded-md bg-navy px-4 py-2 text-xs font-bold text-white hover:bg-navy-800">{t("cookie.accept")}</button>
            <button data-testid="cookie-reject" onClick={() => choose("denied")} className="touch rounded-md border border-slate-300 bg-white px-4 py-2 text-xs font-bold text-navy hover:bg-slate-50">{t("cookie.reject")}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
